module.exports = __webpack_public_path__ + "static/media/about-background.92faa2d1.svg";